import React, { FormEvent, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { hasErrorsApi } from "go-core";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import handleException from "go-core/api/handleException";
import { ApiError } from "go-core/api/types";
import { FormErrorMessageApi } from "go-form/components/FormErrorMessage";
import { FormErrorMessageAlertApi } from "go-form/components/FormErrorMessageAlert";
import { api } from "../../../services/Security/api";
import { ResetPasswordApi } from "../../../services/Security/types";

const ResetPasswordForm = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const [formLoading, setFormLoading] = useState(false);
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const { addFlash, addSuccessFlash } = useFlash();
	const [errors, setErrors] = useState<ApiError[]>([]);

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		const url = window.location.href;
		setFormLoading(true);
		const data: ResetPasswordApi = {
			password,
			password_confirmation: confirmPassword,
			code: url.split("/").pop(),
		};
		try {
			await api.resetPassword(data);
			addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
			history.push("/login");
			setFormLoading(false);
		} catch (err) {
			const exceptionErrors = handleException(err);
			setErrors(exceptionErrors);
			handleError.alert(err, addFlash, ["password", "password_confirmation"]);
			setFormLoading(false);
		}
	};

	return (
		<Form autoComplete="off" noValidate onSubmit={handleSubmit}>
			<FormErrorMessageAlertApi errors={errors} />
			<Form.Group className="form-group">
				<Form.Control
					disabled={formLoading}
					id="password"
					isInvalid={hasErrorsApi(errors, "password")}
					onChange={(e) => setPassword(e.target.value)}
					type="password"
					value={password}
					placeholder={t("modules.security.field.password.title")}
				/>
				<Form.Label htmlFor="password" sm={3}>
					{`${t("modules.security.field.password.title")}*`}
				</Form.Label>
				<FormErrorMessageApi errors={errors} field="password" />
			</Form.Group>
			<Form.Group className="form-group">
				<Form.Control
					disabled={formLoading}
					id="password_confirmation"
					isInvalid={hasErrorsApi(errors, "password_confirmation")}
					onChange={(e) => setConfirmPassword(e.target.value)}
					type="password"
					value={confirmPassword}
					placeholder={t("modules.security.field.confirm_password.title")}
				/>
				<Form.Label htmlFor="password_confirmation" sm={3}>
					{`${t("modules.security.field.confirm_password.title")}*`}
				</Form.Label>
				<FormErrorMessageApi errors={errors} field="password_confirmation" />
			</Form.Group>
			<ButtonLoading loading={formLoading} type="submit" color="primary">
				{t("lib:common.action.set")}
			</ButtonLoading>
		</Form>
	);
};

export default ResetPasswordForm;
